import React, { useEffect } from "react";

import { Grid, Typography, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
// import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";

import useStyles from "./Lobby.styles";
import { getTopGamesStart } from "../../../redux-saga/redux/casino/lobby/casinoGames";
import { formatCategoryName } from "../../../utils/helper";
import Game from "../Game";
import { CASINO_LOBBY_GAMES_LIMIT } from "../../../utils/constants";
import { ReactComponent as LeftArrowIcon } from "../../../assets/images/leftArrow.svg";
import { ReactComponent as RightArrowIcon } from "../../../assets/images/rightArrow.svg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TopGames = (categoryType) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { topGames, topGameLoading } = useSelector(
    (state) => state.casinoGames
  );
  const { isLoggedIn } = useSelector((state) => state.authentication);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getTopGamesStart({
        limit: CASINO_LOBBY_GAMES_LIMIT,
        page: 1,
        isMobile,
        subCategoryType: categoryType.subCategoryType
      })
    );
  }, [dispatch, isLoggedIn]);

  // const slidesToShow = isMobile ? 3 : 7;

  function SampleNextArrow(props) {
    const { onClick, currentSlide } = props;

    // Using the same pattern as your working PrevArrow
    const isLastSlide = currentSlide >= topGames?.length - 1;

    return (
      <div className={`${classes.arrowbutton} ${classes.rightArrow}`}>
        <Button
          onClick={onClick}
          className={classes.frvbtnstyle}
          disabled={isLastSlide}
        >
          <RightArrowIcon className={isLastSlide ? "inactive" : "active"} />
        </Button>
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick, currentSlide } = props;
    return (
      <div className={`${classes.arrowbutton} ${classes.leftArrow}`}>
        <Button
          onClick={onClick}
          className={classes.prvbtnstyle}
          disabled={currentSlide === 0}
        >
          <LeftArrowIcon
            className={currentSlide === 0 ? "inactive" : "active"}
          />
        </Button>
      </div>
    );
  }
  var settings = {
    dots: false,
    infinite: false,
    draggable: false,
    speed: 500,
    slidesToShow: isMobile ? 3 : 7,
    slidesToScroll: isMobile ? 3 : 5,
    initialSlide: 0,
    pauseOnHover: true,
    lazyLoad: true,
    responsive: [
      {
        breakpoint: 1536,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 5
        }
      },
      {
        breakpoint: 1524,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 5
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 5
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  };
  const renderGames = () => {
    return (
      <Grid className={classes.contentWrap}>
        <Grid className={classes.innerHeading} gap={5}>
          <Grid className={classes.innerHeadingLeft}>
            <img
              src="/images/Suggested.png"
              className={classes.heartIcon}
              alt="Star Icon"
              style={{
    filter:
      "brightness(0) saturate(100%) invert(14%) sepia(96%) saturate(7492%) hue-rotate(336deg) brightness(97%) contrast(106%)"
  }}
            />
            <Typography variant="h6" gutterBottom>
              {t("LOBBY.OUR_CASINO_SECTION")}
            </Typography>
          </Grid>
          {/* {topGames?.length >= CASINO_LOBBY_GAMES_LIMIT && (
            <Link
              to="/casino/view-all/topgames"
              state={categoryType}
              className={classes.btnSecondary}
            >
              {t("COMMON.VIEW_ALL")}
            </Link>
          )} */}
        </Grid>
        <Slider
          {...settings}
          nextArrow={<SampleNextArrow />}
          prevArrow={<SamplePrevArrow />}
        >
          {topGames?.map((game, index) => {
            return (
              <div
                key={`${game.masterCasinoGameId}${index}`}
                className="gamesOuter"
              >
                <Game
                  categoryName={formatCategoryName(
                    game?.MasterGameSubCategory?.name
                  )}
                  providerName={game?.MasterCasinoProvider?.name}
                  thumbnailUrl={game?.thumbnailUrl || game?.gameImage || ""}
                  name={game?.name}
                  gameId={game?.masterCasinoGameId}
                  gameTag={game?.tags}
                  isFavorite={!!game.isFavorite}
                  recallFav={CASINO_LOBBY_GAMES_LIMIT}
                />
              </div>
            );
          })}
        </Slider>
      </Grid>
    );
  };

  return (
    <>
      {topGameLoading
        ? null
        : topGames && topGames?.length > 0
          ? renderGames()
          : null}
    </>
  );
};

export default TopGames;
